import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

import { CONFIG, ExceptionService, MessageService, SpinnerService, HttpWrapper } from '../../core';
import { Documentos } from '../shared';
import { Category } from "../../core/models/category.model";
import { environment } from '../../../environments/environment';

let documentsUrl = CONFIG.baseUrls.files;

@Injectable()
export class DocumentService {
  onDbReset = this.messageService.state;

  constructor(
    private http: HttpWrapper,
    private exceptionService: ExceptionService,
    private messageService: MessageService,
    private spinnerService: SpinnerService
  ) {
    
  }

  getCategories() {
    //this.spinnerService.show();
    return <Observable<Category[]>>this.http
      .get(`${documentsUrl}/Categories`)
      .map(res => this.extractData<Category[]>(res))
      .catch(this.exceptionService.catchBadResponse)
      .finally(() => {
       // this.spinnerService.hide()
      });
  }

  getDocuments(catId: number) {
    //this.spinnerService.show();
    return <Observable<Documentos[]>>this.http
      .get(`${documentsUrl}/Documents/${catId}`)
      .map(res => this.extractData<Documentos[]>(res))
      .catch(this.exceptionService.catchBadResponse)
      .finally(() => {
     //   this.spinnerService.hide()
      });
  }


  private extractData<T>(res: Response) {
    if (res.status < 200 || res.status >= 300) {
      throw new Error('Bad response status: ' + res.status);
    }
    let body = res.json ? res.json() : null;
    return <T>(body || {});
  }
}



// WEBPACK FOOTER //
// ./src/app/documents/shared/document.service.ts